import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSavedProperties } from '../../../contexts/saved-properties';
const VARIANT_CLASS = {
    overlay: 'save-property-button save-property-button--overlay',
    icon: 'save-property-button save-property-button--icon',
    hero: 'save-property-button btn btn-light fw-semibold align-self-start mt-2',
};
// The heart. It sits inside rows and popups that open something on click, so it keeps its click to
// itself.
const SavePropertyButton = (props) => {
    const savedProperties = useSavedProperties();
    const isSaved = savedProperties.isSaved(props.parcelId);
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        savedProperties.toggle(props.parcelId);
    };
    return (_jsxs("button", { type: "button", className: `${VARIANT_CLASS[props.variant]}${isSaved ? ' is-saved' : ''}`, "aria-pressed": isSaved, "aria-label": props.variant === 'hero' ? undefined : 'Save property', title: isSaved ? 'Remove from saved' : 'Save', onClick: handleClick, children: [_jsx("i", { className: `bi ${isSaved ? 'bi-heart-fill' : 'bi-heart'}`, "aria-hidden": "true" }), props.variant === 'hero' && _jsx("span", { children: isSaved ? 'Saved' : 'Save' })] }));
};
export default SavePropertyButton;
